import { render } from "./ExpeditionsComponent.vue?vue&type=template&id=17f99dc2"
import script from "./ExpeditionsComponent.vue?vue&type=script&lang=js"
export * from "./ExpeditionsComponent.vue?vue&type=script&lang=js"

import "./ExpeditionsComponent.vue?vue&type=style&index=0&id=17f99dc2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__